/* eslint-disable react/no-unknown-property */

import React from 'react';
import { getLocalePrice } from '../utils/functions'; //eslint-disable-line

export const HISTORY_UPDATE_INTERVAL = 7000;

export const SUBSCRIPTION_PER_PAGE = 100;

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDfs49C1bDe8cNe_lQyzu0po29WUfE-OJ8';

export const PRO_SUBSCRIPTIONS_BY_TYPEID = new Map([
  [
    '6',
    {
      type: '6',
      order: 6,
      name: gettext('Custom Pro Trial'),
      credit: 50,
      price_year: 0,
      price: 0,
      demo: true,
    },
  ],
  [
    '5',
    {
      type: '5',
      order: 5,
      name: gettext('48 Hours Trial'),
      credit: 200,
      price_year: 0,
      price: 0,
      demo: true,
    },
  ],
  [
    '4',
    {
      type: '4',
      order: 4,
      name: gettext('Complementary'),
      credit: -1,
      price_year: 0,
      price: 0,
      demo: true,
    },
  ],
  [
    '3',
    {
      type: '3',
      order: 3,
      name: gettext('PRO UNLIMITED'),
      credit: -1,
      price_year: 299,
      price: 449,
      demo: false,
    },
  ],
  [
    '2',
    {
      type: '2',
      order: 2,
      name: gettext('PRO 500'),
      credit: 500,
      price_year: 199,
      price: 299,
      demo: false,
    },
  ],
  [
    '1',
    {
      type: '1',
      order: 1,
      name: gettext('PRO 200'),
      credit: 200,
      price: 149,
      price_year: 99,
      demo: false,
    },
  ],
]);

export const PRO_SUBSCRIPTIONS_BY_NAME = new Map([
  [
    'PRO_DEMO_200',
    {
      type_id: '5',
      type: 'PRO_DEMO_200',
      name: gettext('48 Hours Trial'),
      credit: 200,
      price_year: 0,
      price: 0,
    },
  ],
  [
    'PRO_DEMO_UNLIMITED',
    {
      type_id: '4',
      type: 'PRO_DEMO_UNLIMITED',
      name: gettext('Complementary'),
      credit: -1,
      price_year: 0,
      price: 0,
    },
  ],
  [
    'PRO_UNLIMITED',
    {
      type_id: '3',
      type: 'PRO_UNLIMITED',
      name: gettext('PRO UNLIMITED'),
      credit: -1,
      price_year: 299,
      price: 449,
    },
  ],
  [
    'PRO_500',
    {
      type_id: '2',
      type: 'PRO_500',
      name: gettext('PRO 500'),
      credit: 500,
      price_year: 199,
      price: 299,
    },
  ],
  [
    'PRO_200',
    {
      type_id: '1',
      type: 'PRO_200',
      name: gettext('PRO 200'),
      credit: 200,
      price_year: 99,
      price: 149,
    },
  ],
]);

export const DEMO_SUBSCRIPTION = ['4', '5'];

export const SOCIAL_URL = window.__CONFIG__ ? window.__CONFIG__.SOCIAL_URL : '/login/pipl/';
export const BASE_ACCOUNTS_URL = window.__CONFIG__ ? window.__CONFIG__.ACCOUNTS_URL : '/accounts';
export const BASE_URL = window.__CONFIG__ ? window.__CONFIG__.BASE_URL : '/';

export const GENERAL_ERROR = gettext(
  'Sorry, something went wrong and our technical team was automatically notified, please try again. If this continues, please contact us at pro.sales@pipl.com.',
);

export const MESSAGES = {
  USER_DO_NOT_HAVE_SUBSCRIPTION: gettext('Hey, looks like you have no subscription. How about creating one?'),
  USER_DO_NOT_HAVE_HISTORY: gettext('Hey, looks like you have no search history, How about running some searches ?'),

  REASSIGN_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  REASSIGN_PROGRESS_MSG: gettext('Assigning subscription, please wait...'),
  REASSIGN_COMPLETE_SUCCESS: gettext("Yay! You've successfully assigned the subscription"),
  UNASSIGN_COMPLETE_SUCCESS: gettext("Yay! You've successfully unassigned the subscription"),

  ASSIGN_MULTI_USERS_COMPLETED: gettext('Yay! you’ve successfully assigned your subscriptions'),

  UPGRADE_SUBSCRIPTION_SUCCESS: gettext('You successfully changed your subscription'),
  UPGRADE_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  UPGRADE_PROGRESS_MSG: gettext('Changing subscription'),

  UPDATE_RENEWAL_PROGRESS_MSG: gettext('Updating your auto renewal'),

  CHANGE_SUBSCRIPTION_IS_SAME: gettext(
    'No change was applied. The requested subscription level and period are the same as they currently are.',
  ),

  DOWNGRADE_SUBSCRIPTION_SUCCESS: gettext('You successfully changed your subscription'),
  DOWNGRADE_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  DOWNGRADE_PROGRESS_MSG: gettext('Changing subscription'),

  CANCEL_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  CANCEL_PROGRESS_MSG: gettext('Canceling your subscription...'),
  CANCEL_COMPLETED_SUCCESS: gettext('You’ve successfully canceled your subscription, we’re sorry to see you go.'),

  AUTO_RENEWAL_COMPLETED_SUCCESS: gettext('You’ve successfully activated auto-renewal for your subscription.'),

  REDUCE_SUCCESS: gettext("You've successfully reduced the number of subscriptions"),
  CANCEL_REDUCE_SUCCESS: gettext('Seat reduction was cancelled'),

  RENEWAL_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  RENEWAL_PROGRESS_MSG: gettext('Re-activating your subscription...'),
  RENEWAL_COMPLETED_SUCCESS: gettext('You’ve successfully reactivated your subscription. Welcome back!'),

  NEW_SUBSCRIPTION_FAILURE_GENERAL_ERROR: GENERAL_ERROR,
  NEW_SUBSCRIPTION_PROGRESS_MSG: gettext('Adding subscription...'),
  NEW_SUBSCRIPTIONS_PROGRESS_MSG: gettext('Adding subscriptions...'),
  NEW_SUBSCRIPTION_COMPLETED_SUCCESS: gettext('Congratulations! You’ve successfully added a new subscription'),
  NEW_SUBSCRIPTIONS_COMPLETED_SUCCESS: gettext('Congratulations! You’ve successfully added a new subscriptions'),

  ERROR_FETCHING_SUBSCRIPTION: gettext(
    'Sorry, we’re unable to retrieve your subscriptions, please refresh the page and try again. If you still see this message, please contact us at mail@pipl.com.',
  ),
  ERROR_FETCHING_FILTERED_USERS: gettext(
    'Sorry, we’re unable to retrieve your users, please refresh the page and try again. If you still see this message, please contact us at mail@pipl.com.',
  ),
  ERROR_FETCHING_HISTORY: gettext(
    'Sorry, we’re unable to retrieve your history log, please refresh the page and try again.',
  ),

  CREATE_ACCOUNT_SUCCESS: gettext('Account created successfully'),
  CREATE_ACCOUNT_WAITING: gettext('Hang on, we’re creating the account...'),
  CREATE_ACCOUNT_FAILED: gettext(
    'Sorry, there was an error creating the account, please try again. If you try again and still see this message, please contact us at mail@pipl.com. ',
  ),

  CREATE_PAYMENT_SUCCESS: gettext('Your credit card was added successfully'),
  CREATE_PAYMENT_WAITING: gettext('Validating card details...'),
  CREATE_PAYMENT_FAILED: gettext(
    'Sorry, we could not validate your card details, please verify the card information or try another card.',
  ),

  CREATE_ORGANIZATION_SUCCESS: gettext('Organization created successfully'),
  CREATE_ORGANIZATION_WAITING: gettext('Hang on, we’re creating the organization...'),
  CREATE_ORGANIZATION_FAILED: gettext(
    'Sorry, there was an error creating the organization, please try again. If you try again and still see this message, please contact us at mail@pipl.com. ',
  ),

  CREATE_SUBSCRIPTION_SUCCESS: gettext('Subscription created Successfully'),
  CREATE_SUBSCRIPTION_WAITING: gettext('Hang on, we’re creating your subscription...'),
  CREATE_SUBSCRIPTION_FAILED: gettext(
    'Sorry, there was an error creating the subscription, please try again. If you try again and still see this message, please contact us at mail@pipl.com.',
  ),

  CREATE_SEATS_SUCCESS: gettext('Seats created Successfully'),
  CREATE_SEATS_WAITING: gettext('Hang on, we’re creating your subscription...'),
  CREATE_SEATS_FAILED: gettext(
    'Sorry, there was an error creating the seats, please try again. If you try again and still see this message, please contact us at mail@pipl.com.',
  ),
  ASSIGN_MULTI_USERS_WAITING: gettext('Assigning users...'),
  ASSIGN_MULTI_USERS_FAILED: gettext(
    'Sorry, something went wrong, please try again. If this continues, please contact us at pro.sales@pipl.com',
  ),

  DEMO_REQUEST_SUCCESS: gettext('Request sent Successfully'),
  DEMO_REQUEST_WAITING: gettext('Sending your request...'),
  DEMO_REQUEST_FAILED: gettext(
    'Sorry, there was an error sending your request, please try again. If you try again and still see this message, please contact us at mail@pipl.com.',
  ),

  VERIFY_VOUCHER_SUCCESS: gettext('Subscription created Successfully'),
  VERIFY_VOUCHER_WAITING: gettext('Hang on, we’re verifying your voucher...'),
  VERIFY_VOUCHER_FAILED: gettext(
    'Sorry, there was an error creating the subscription, please try again. If you try again and still see this message, please contact us at mail@pipl.com.',
  ),

  VOUCHER_REQUIRED: gettext('Voucher invalid, try to copy and paste it again.'),

  USERS_LIST_VALIDATION_WAITING: gettext('Validating your users list...'),
  USERS_LIST_VALIDATION_FAILED: gettext(
    'Something is wrong, please review your list. Invalid entries are marked in red.',
  ),
  USERS_LIST_TOO_MUCH_USERS: gettext(
    "Too many users, not enough unassigned subscriptions, you'll need more subscriptions or less users",
  ),
  USERS_LIST_EMPTY: gettext('Your users list is empty, this is sad'),
  USERS_LIST_HAS_DUPLICATES_EMAILS: gettext('This email is already in your list'),
  USERS_LIST_CELL_HAS_EXISTS_EMAIL: gettext('User email is registered elsewhere'),
  USERS_LIST_CELL_HAS_INVALID_EMAIL: gettext('Invalid email address, please use a valid service provider.'),
  USERS_LIST_CELL_HAS_INVITEABLE_EMAIL: gettext('This user already exists, we will invite him '),
  USERS_LIST_CELL_HAS_SUBSCRIPTION: gettext('User was already assigned a subscription'),
  USERS_LIST_HAS_EXISTING_EMAIL: gettext(
    'Some of the emails already have a pipl account under a different organization',
  ),
  USERS_LIST_HAS_INVALID_EMAIL: gettext('Some of the emails are invalid, Please use a valid service provider'),

  CREDIT_CARD_NAME_REQUIRED: gettext('Hey, we’ll need that'),
  CREDIT_CARD_CITY_REQUIRED: gettext('We’ll need the billing address'),
  CREDIT_CARD_ADDRESS_REQUIRED: gettext('We’ll need the billing address'),
  CREDIT_CARD_POSTALCODE_REQUIRED: gettext('We’ll need the billing address'),
  CREATE_USER_ALREADY_REGISTERED: gettext('User email is registered elsewhere'),
  CREATE_USER_FULLNAME_REQUIRED: gettext('Hey, what’s your name?'),
  CREATE_USER_EMAIL_REQUIRED: gettext('We’ll need a valid email to activate this account'),
  CREATE_USER_EMAIL_EXISTS: gettext(
    'Excuse me, but I feel like we’ve met (your email) before. Try to login into your account.',
  ),
  CREATE_USER_EMAIL_IS_INVITEABLE: gettext('Email exists, an invitation will be sent'),
  CREATE_USER_PASSWORD_REQUIRED: gettext('Sometimes size really does matter. Password should be at least 6 characters'),
  CREATE_USER_RECAPCHA_REQUIRED: gettext('Are you human ? Prove it!'),
  CREATE_USER_TOS_REQUIRED: gettext('Please read and agree to the terms'),

  REQUEST_DEMO_COMPANY_REQUIRED: gettext('If you work for no one, just write "none"'),
  REQUEST_DEMO_PHONE_INVALID: gettext("Sorry, this doesn't seem like a valid phone number"),
  REQUEST_DEMO_PHONE_REQUIRED: gettext('We’ll need a valid phone to get in touch with you'),
  REQUEST_DEMO_FULL_NAME_REQUIRED: gettext("Hey, what's your name"),
  REQUEST_DEMO_EMAIL_REQUIRED: gettext('We’ll need a valid email to get in touch with you'),
  REQUEST_DEMO_JOB_TITLE_REQUIRED: gettext('If you have no job title, just write "none"'),
  REQUEST_DEMO_DECISION_MAKER_REQUIRED: gettext("Are you choosing your team's tools ?"),

  ORGANIZATION_DETAILS_NAME_REQUIRED: gettext('Hey, your organization must have a name'),
  ORGANIZATION_DETAILS_CITY_REQUIRED: gettext('We’ll need the billing city'),
  ORGANIZATION_DETAILS_ADDRESS_REQUIRED: gettext('We’ll need the billing address'),
  ORGANIZATION_DETAILS_POSTALCODE_REQUIRED: gettext('We’ll need a postal code'),
  ORGANIZATION_DETAILS_ADDRESS_INVALID: gettext('We’ll need a valid address'),
  ORGANIZATION_DETAILS_INVOICE_EMAIL_REQUIRED: gettext('We’ll need an email to send you invoices'),
  ORGANIZATION_DETAILS_INVOICE_EMAIL_INVALID: gettext('We’ll need a valid email to send you invoices'),
  ORGANIZATION_DETAILS_PHONE_INVALID: gettext("Sorry, this doesn't seem like a valid phone number"),
  ORGANIZATION_DETAILS_URL_INVALID: gettext("Sorry, this doesn't seem like a valid website url"),

  ORGANIZATION_FORM_CHECK_ADDRESS_WAITING: gettext('Calculating tax rate...'),

  FILE_UPLOAD_FILE_TOO_BIG: gettext('Sorry, maximum file size is 10MB'),
  FILE_UPLOAD_FILE_NOT_SUPPORTED: gettext('Sorry, we could not parse this file, we accept either csv or excel files'),

  UPLOAD_USERS_FILE_FAILED: gettext('Sorry, we could not parse this file, we accept either csv or excel files'),
  UPDATE_ORGANIZATION_USERS_FAILURE: gettext(
    'Sorry, there was an error fetching your organization members, please try again. If you try again and still see this message, please contact us at mail@pipl.com. ',
  ),

  ADVANCED_SEARCH_PARTIAL_NAME_ERROR: gettext('Both first name and last name are mandatory'),
  ADVANCED_SEARCH_PHONE_ERROR: gettext('Both Country Code and Number are mandatory'),
  ADVANCED_SEARCH_INVALID_FIRST_NAME: gettext('First name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_LAST_NAME: gettext('Last name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_EMAIL: gettext('Invalid Email address'),
  ADVANCED_SEARCH_INVALID_USERNAME: gettext('Username must be at least 3 characters long'),

  ADVANCED_SEARCH_INVALID_COUNTRY_CODE: gettext('Invalid Country code'),
  ADVANCED_SEARCH_ADDRESS_MISSING_COUNTRY: gettext('Country is mandatory'),
  ADVANCED_SEARCH_INVALID_NUMBER: gettext('Invalid Phone number'),

  ADVANCED_SEARCH_INVALID_REL_FIRST_NAME: gettext('First name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_REL_LAST_NAME: gettext('Last name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_ORGANIZATION: gettext('Organization name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_TITLE: gettext('Title must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_SCHOOL: gettext('School name must be at least 2 characters long'),
  ADVANCED_SEARCH_INVALID_DEGREE: gettext('Educational degree must be at least 2 characters long'),
  ADVANCED_SEARCH_MISSING_MANDATORY_FIELDS: gettext(
    'At least one of the following fields is mandatory. (Name, Email, Phone, Username, Address)',
  ),
  ADVANCED_SEARCH_INVALID_EDUCATION: gettext('Education must have school filled in'),

  ADVANCED_SEARCH_INVALID_DOB: gettext('Please provide a valid age,range or date birth. (Only one of them)'),
  ADVANCED_SEARCH_INVALID_SP: gettext('Please provide a valid Search Pointer'),

  APPLY_DISCOUNT_SUCCESS: gettext('New promo code was applied successfully'),
  APPLY_DISCOUNT_WAITING: gettext('Applying new promo code ...'),
  APPLY_DISCOUNT_FAILED: gettext('Sorry, we could not apply this promo code. Please contact your account manager'),
  APPLY_DISCOUNT_WRONG_CODE: gettext('Hey, what’s your promo code ?'),

  CREATE_STRIPE_TOKEN_IN_FAILED: gettext(
    'Sorry,  we could not validate your card details, please verify the card information or try another card.',
  ),
  ORGANIZATION_SETTINGS_FAILED_UPDATE: gettext(
    'Sorry, we could not update your settings. Please contact your account manager',
  ),
};

export const SLIDER_SETTINGS = renewalCycle => ({
  1: {
    style: {
      textAlign: 'center',
      float: 'left',
      left: '-52px',
      width: '100px',
      marginLeft: 0,
    },
    label: (
      <div className="slider-text" test-id="searches-amount-200">
        <div className="slider-upper-text">200</div>
        <div className="slider-bottom-text">
          {renewalCycle === 'YEAR' ? getLocalePrice(99) : getLocalePrice(149)}
          <small>{gettext('user / month')}</small>
        </div>
      </div>
    ),
  },
  2: {
    style: {
      textAlign: 'center',
      float: 'left',
      width: '100px',
      right: '0',
      left: '0',
      margin: 'auto',
      marginLeft: 0,
    },
    label: (
      <div className="slider-text" test-id="searches-amount-500">
        <div className="slider-upper-text">500</div>
        <div className="slider-bottom-text">
          {renewalCycle === 'YEAR' ? getLocalePrice(199) : getLocalePrice(299)}
          <small>{gettext('user / month')}</small>
        </div>
      </div>
    ),
  },
  3: {
    style: {
      textAlign: 'center',
      float: 'left',
      left: 'initial',
      right: '-60px',
      width: '126px',
      marginLeft: 0,
    },
    label: (
      <div className="slider-text" test-id="searches-amount-unlimited">
        <div className="slider-upper-text">{gettext('UNLIMITED')}</div>
        <div className="slider-bottom-text">
          {renewalCycle === 'YEAR' ? getLocalePrice(299) : getLocalePrice(449)}
          <small>{gettext('user / month')}</small>
        </div>
      </div>
    ),
  },
});

export const STATES_BY_COUNTRY = {
  CA: [
    ['AB', 'Alberta'],
    ['BC', 'British Columbia'],
    ['MB', 'Manitoba'],
    ['NB', 'New Brunswick'],
    ['NL', 'Newfoundland and Labrador'],
    ['NS', 'Nova Scotia'],
    ['NU', 'Nunavut'],
    ['NT', 'Northwest Territories'],
    ['ON', 'Ontario'],
    ['PE', 'Prince Edward Island'],
    ['QC', 'Quebec'],
    ['SK', 'Saskatchewan'],
    ['YT', 'Yukon'],
  ],
  US: [
    ['AL', 'Alabama'],
    ['AK', 'Alaska'],
    ['AZ', 'Arizona'],
    ['AR', 'Arkansas'],
    ['CA', 'California'],
    ['CO', 'Colorado'],
    ['CT', 'Connecticut'],
    ['DC', 'District of Columbia'],
    ['DE', 'Delaware'],
    ['FL', 'Florida'],
    ['GA', 'Georgia'],
    ['HI', 'Hawaii'],
    ['ID', 'Idaho'],
    ['IL', 'Illinois'],
    ['IN', 'Indiana'],
    ['IA', 'Iowa'],
    ['KS', 'Kansas'],
    ['KY', 'Kentucky'],
    ['LA', 'Louisiana'],
    ['ME', 'Maine'],
    ['MD', 'Maryland'],
    ['MA', 'Massachusetts'],
    ['MI', 'Michigan'],
    ['MN', 'Minnesota'],
    ['MS', 'Mississippi'],
    ['MO', 'Missouri'],
    ['MT', 'Montana'],
    ['NE', 'Nebraska'],
    ['NV', 'Nevada'],
    ['NH', 'New Hampshire'],
    ['NJ', 'New Jersey'],
    ['NM', 'New Mexico'],
    ['NY', 'New York'],
    ['NC', 'North Carolina'],
    ['ND', 'North Dakota'],
    ['OH', 'Ohio'],
    ['OK', 'Oklahoma'],
    ['OR', 'Oregon'],
    ['PA', 'Pennsylvania'],
    ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'],
    ['SD', 'South Dakota'],
    ['TN', 'Tennessee'],
    ['TX', 'Texas'],
    ['UT', 'Utah'],
    ['VT', 'Vermont'],
    ['VA', 'Virginia'],
    ['WA', 'Washington'],
    ['WV', 'West Virginia'],
    ['WI', 'Wisconsin'],
    ['WY', 'Wyoming'],
    ['AS', 'American Samoa'],
    ['GU', 'Guam'],
    ['MP', 'Northern Mariana Islands'],
    ['PR', 'Puerto Rico'],
    ['UM', 'United States Minor Outlying Islands'],
    ['VI', 'Virgin Islands'],
  ],
};

export const COUNTRIES = [
  ['AF', 'Afghanistan'],
  ['AX', 'Åland Islands'],
  ['AL', 'Albania'],
  ['DZ', 'Algeria'],
  ['AS', 'American Samoa'],
  ['AD', 'Andorra'],
  ['AO', 'Angola'],
  ['AI', 'Anguilla'],
  ['AQ', 'Antarctica'],
  ['AG', 'Antigua and Barbuda'],
  ['AR', 'Argentina'],
  ['AM', 'Armenia'],
  ['AW', 'Aruba'],
  ['AU', 'Australia'],
  ['AT', 'Austria'],
  ['AZ', 'Azerbaijan'],
  ['BS', 'Bahamas'],
  ['BH', 'Bahrain'],
  ['BD', 'Bangladesh'],
  ['BB', 'Barbados'],
  ['BY', 'Belarus'],
  ['BE', 'Belgium'],
  ['BZ', 'Belize'],
  ['BJ', 'Benin'],
  ['BM', 'Bermuda'],
  ['BT', 'Bhutan'],
  ['BO', 'Bolivia, Plurinational State of'],
  ['BQ', 'Bonaire, Sint Eustatius and Saba'],
  ['BA', 'Bosnia and Herzegovina'],
  ['BW', 'Botswana'],
  ['BV', 'Bouvet Island'],
  ['BR', 'Brazil'],
  ['IO', 'British Indian Ocean Territory'],
  ['BN', 'Brunei Darussalam'],
  ['BG', 'Bulgaria'],
  ['BF', 'Burkina Faso'],
  ['BI', 'Burundi'],
  ['KH', 'Cambodia'],
  ['CM', 'Cameroon'],
  ['CA', 'Canada'],
  ['CV', 'Cape Verde'],
  ['KY', 'Cayman Islands'],
  ['CF', 'Central African Republic'],
  ['TD', 'Chad'],
  ['CL', 'Chile'],
  ['CN', 'China'],
  ['CX', 'Christmas Island'],
  ['CC', 'Cocos (Keeling) Islands'],
  ['CO', 'Colombia'],
  ['KM', 'Comoros'],
  ['CG', 'Congo'],
  ['CD', 'Congo, the Democratic Republic of the'],
  ['CK', 'Cook Islands'],
  ['CR', 'Costa Rica'],
  ['CI', "Côte d'Ivoire"],
  ['HR', 'Croatia'],
  ['CU', 'Cuba'],
  ['CW', 'Curaçao'],
  ['CY', 'Cyprus'],
  ['CZ', 'Czech Republic'],
  ['DK', 'Denmark'],
  ['DJ', 'Djibouti'],
  ['DM', 'Dominica'],
  ['DO', 'Dominican Republic'],
  ['EC', 'Ecuador'],
  ['EG', 'Egypt'],
  ['SV', 'El Salvador'],
  ['GQ', 'Equatorial Guinea'],
  ['ER', 'Eritrea'],
  ['EE', 'Estonia'],
  ['ET', 'Ethiopia'],
  ['FK', 'Falkland Islands (Malvinas)'],
  ['FO', 'Faroe Islands'],
  ['FJ', 'Fiji'],
  ['FI', 'Finland'],
  ['FR', 'France'],
  ['GF', 'French Guiana'],
  ['PF', 'French Polynesia'],
  ['TF', 'French Southern Territories'],
  ['GA', 'Gabon'],
  ['GM', 'Gambia'],
  ['GE', 'Georgia'],
  ['DE', 'Germany'],
  ['GH', 'Ghana'],
  ['GI', 'Gibraltar'],
  ['GR', 'Greece'],
  ['GL', 'Greenland'],
  ['GD', 'Grenada'],
  ['GP', 'Guadeloupe'],
  ['GU', 'Guam'],
  ['GT', 'Guatemala'],
  ['GG', 'Guernsey'],
  ['GN', 'Guinea'],
  ['GW', 'Guinea-Bissau'],
  ['GY', 'Guyana'],
  ['HT', 'Haiti'],
  ['HM', 'Heard Island and McDonald Mcdonald Islands'],
  ['VA', 'Holy See (Vatican City State)'],
  ['HN', 'Honduras'],
  ['HK', 'Hong Kong'],
  ['HU', 'Hungary'],
  ['IS', 'Iceland'],
  ['IN', 'India'],
  ['ID', 'Indonesia'],
  ['IR', 'Iran, Islamic Republic of'],
  ['IQ', 'Iraq'],
  ['IE', 'Ireland'],
  ['IM', 'Isle of Man'],
  ['IL', 'Israel'],
  ['IT', 'Italy'],
  ['JM', 'Jamaica'],
  ['JP', 'Japan'],
  ['JE', 'Jersey'],
  ['JO', 'Jordan'],
  ['KZ', 'Kazakhstan'],
  ['KE', 'Kenya'],
  ['KI', 'Kiribati'],
  ['KP', "Korea, Democratic People's Republic of"],
  ['KR', 'Korea, Republic of'],
  ['KW', 'Kuwait'],
  ['KG', 'Kyrgyzstan'],
  ['LA', "Lao People's Democratic Republic"],
  ['LV', 'Latvia'],
  ['LB', 'Lebanon'],
  ['LS', 'Lesotho'],
  ['LR', 'Liberia'],
  ['LY', 'Libya'],
  ['LI', 'Liechtenstein'],
  ['LT', 'Lithuania'],
  ['LU', 'Luxembourg'],
  ['MO', 'Macao'],
  ['MK', 'Macedonia, the Former Yugoslav Republic of'],
  ['MG', 'Madagascar'],
  ['MW', 'Malawi'],
  ['MY', 'Malaysia'],
  ['MV', 'Maldives'],
  ['ML', 'Mali'],
  ['MT', 'Malta'],
  ['MH', 'Marshall Islands'],
  ['MQ', 'Martinique'],
  ['MR', 'Mauritania'],
  ['MU', 'Mauritius'],
  ['YT', 'Mayotte'],
  ['MX', 'Mexico'],
  ['FM', 'Micronesia, Federated States of'],
  ['MD', 'Moldova, Republic of'],
  ['MC', 'Monaco'],
  ['MN', 'Mongolia'],
  ['ME', 'Montenegro'],
  ['MS', 'Montserrat'],
  ['MA', 'Morocco'],
  ['MZ', 'Mozambique'],
  ['MM', 'Myanmar'],
  ['NA', 'Namibia'],
  ['NR', 'Nauru'],
  ['NP', 'Nepal'],
  ['NL', 'Netherlands'],
  ['NC', 'New Caledonia'],
  ['NZ', 'New Zealand'],
  ['NI', 'Nicaragua'],
  ['NE', 'Niger'],
  ['NG', 'Nigeria'],
  ['NU', 'Niue'],
  ['NF', 'Norfolk Island'],
  ['MP', 'Northern Mariana Islands'],
  ['NO', 'Norway'],
  ['OM', 'Oman'],
  ['PK', 'Pakistan'],
  ['PW', 'Palau'],
  ['PS', 'Palestine, State of'],
  ['PA', 'Panama'],
  ['PG', 'Papua New Guinea'],
  ['PY', 'Paraguay'],
  ['PE', 'Peru'],
  ['PH', 'Philippines'],
  ['PN', 'Pitcairn'],
  ['PL', 'Poland'],
  ['PT', 'Portugal'],
  ['PR', 'Puerto Rico'],
  ['QA', 'Qatar'],
  ['RE', 'Réunion'],
  ['RO', 'Romania'],
  ['RU', 'Russian Federation'],
  ['RW', 'Rwanda'],
  ['BL', 'Saint Barthélemy'],
  ['SH', 'Saint Helena, Ascension and Tristan da Cunha'],
  ['KN', 'Saint Kitts and Nevis'],
  ['LC', 'Saint Lucia'],
  ['MF', 'Saint Martin (French part)'],
  ['PM', 'Saint Pierre and Miquelon'],
  ['VC', 'Saint Vincent and the Grenadines'],
  ['WS', 'Samoa'],
  ['SM', 'San Marino'],
  ['ST', 'Sao Tome and Principe'],
  ['SA', 'Saudi Arabia'],
  ['SN', 'Senegal'],
  ['RS', 'Serbia'],
  ['SC', 'Seychelles'],
  ['SL', 'Sierra Leone'],
  ['SG', 'Singapore'],
  ['SX', 'Sint Maarten (Dutch part)'],
  ['SK', 'Slovakia'],
  ['SI', 'Slovenia'],
  ['SB', 'Solomon Islands'],
  ['SO', 'Somalia'],
  ['ZA', 'South Africa'],
  ['GS', 'South Georgia and the South Sandwich Islands'],
  ['SS', 'South Sudan'],
  ['ES', 'Spain'],
  ['LK', 'Sri Lanka'],
  ['SD', 'Sudan'],
  ['SR', 'Suriname'],
  ['SJ', 'Svalbard and Jan Mayen'],
  ['SZ', 'Swaziland'],
  ['SE', 'Sweden'],
  ['CH', 'Switzerland'],
  ['SY', 'Syrian Arab Republic'],
  ['TW', 'Taiwan, Province of China'],
  ['TJ', 'Tajikistan'],
  ['TZ', 'Tanzania, United Republic of'],
  ['TH', 'Thailand'],
  ['TL', 'Timor-Leste'],
  ['TG', 'Togo'],
  ['TK', 'Tokelau'],
  ['TO', 'Tonga'],
  ['TT', 'Trinidad and Tobago'],
  ['TN', 'Tunisia'],
  ['TR', 'Turkey'],
  ['TM', 'Turkmenistan'],
  ['TC', 'Turks and Caicos Islands'],
  ['TV', 'Tuvalu'],
  ['UG', 'Uganda'],
  ['UA', 'Ukraine'],
  ['AE', 'United Arab Emirates'],
  ['GB', 'United Kingdom'],
  ['US', 'United States'],
  ['UM', 'United States Minor Outlying Islands'],
  ['UY', 'Uruguay'],
  ['UZ', 'Uzbekistan'],
  ['VU', 'Vanuatu'],
  ['VE', 'Venezuela, Bolivarian Republic of'],
  ['VN', 'Viet Nam'],
  ['VG', 'Virgin Islands, British'],
  ['VI', 'Virgin Islands, U.S.'],
  ['WF', 'Wallis and Futuna'],
  ['EH', 'Western Sahara'],
  ['YE', 'Yemen'],
  ['ZM', 'Zambia'],
  ['ZW', 'Zimbabwe'],
];

export const SUBSCRIPTION_TYPE = {
  NOTHING_LEFT: 0,
  UNLIMITED: -1,
  NO_SUBSCRIPTION: -2,
};

export const DESKTOP_WIDTH_PX = 1000;
export const MOBILE_WIDTH_PX = DESKTOP_WIDTH_PX - 1;

export const STEPS = {
  PRO_NEW_ONBOARDING_CREATE_ORGANIZATION: 'PRO_NEW_ONBOARDING_CREATE_ORGANIZATION',
  PRO_NEW_ONBOARDING_ADD_CREDIT_CARD: 'PRO_NEW_ONBOARDING_ADD_CREDIT_CARD',
  PRO_NEW_ONBOARDING_NEW_SUBSCRIPTION: 'PRO_NEW_ONBOARDING_NEW_SUBSCRIPTION',
  PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION_CREATE_ORGANIZATION:
    'PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION_CREATE_ORGANIZATION',
  PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION_ADD_CREDIT_CARD:
    'PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION_ADD_CREDIT_CARD',
  PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION: 'PRO_NEW_MANAGEMENT_PANEL_NEW_SUBSCRIPTION',
  PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION_CREATE_ORGANIZATION:
    'PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION_CREATE_ORGANIZATION',
  PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION_ADD_CREDIT_CARD:
    'PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION_ADD_CREDIT_CARD',
  PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION: 'PRO_NEW_MANAGEMENT_PANEL_CHANGE_SUBSCRIPTION',
};

export const PURCHASE_STEPS = {
  BILLING: 1,
  PAYMENT: 2,
  CONFIRMATION: 3,
};

export const PIPL_SERVER_SECURITY_URL_PREFIX = 'security/';
